import { hdrm } from '@yola/ws-sdk';

const generateSnippetId = () => `snippet-${hdrm.helpers.generateIdSuffix()}`;

export default generateSnippetId;
